import styled from 'styled-components';

import { Text, Image, spaceMixin } from '@zillow/constellation';

const containerMaxWidth = '100%';

export const StyledContainer = styled.div``;

export const StyledBodyContainer = styled.div`
    max-width: ${containerMaxWidth};
    margin: 0 auto;
    padding: ${props => props &&
        props.theme &&
        props.theme.ns &&
        spaceMixin('xs')};
`;

export const StyledBannerContainer = styled.div``;

export const StyledCenterText = styled(Text)`
    text-align: center;
`;

export const StyledGuaranteeIcon = styled(Image)`
    margin-right: ${spaceMixin('xs')};
`;
